import { useEffect } from 'react';

import { useWindowRef } from '../providers/WindowRefContext';

export type OnWindowMessageType = (funcName: string, data: any) => void;

export const onMessageHandler = (event: MessageEvent<any>, callback: (funcName: string, data: any) => void) => {
    let { data } = event;

    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            // silent fail, we don't care because we don't always get json to begin with
        }
    }

    if (data.func === 'open_moodle') {
        callback(data.func, data.url);
    } else if (data.data) {
        callback(data.func, data.data);
    } else {
        callback(data.func, data);
    }
};

export const useOnMessage = (callback: OnWindowMessageType) => {
    const target = useWindowRef();

    useEffect(() => {
        const handler = (event: MessageEvent<any>) => onMessageHandler(event, callback);

        target.addEventListener('message', handler);

        return () => {
            target.removeEventListener('message', handler);
        };
    }, [callback, target]);
};
